import { FormControlLabel, Grid, Radio, RadioGroup } from "@material-ui/core";
import React, { useContext } from "react";
import { BuyingInsuranceContextStore } from "../../../context/BuyingInsuranceContext";

export default () => {
  const { fleetInformation, setPublishableFleetYesNo, setProceduresControlFleetYesNo,fleetErrors } = useContext(
    BuyingInsuranceContextStore
  );

  const handlePublishableOnChange = (e) => {
    const { value } = e.target
    setPublishableFleetYesNo(value);
    setProceduresControlFleetYesNo(value === 'true' ? undefined : 'false');
  };
  const handleProceduresControlOnChange = (e) => {
    setProceduresControlFleetYesNo(e.target.value);
  };

  return (
    <>
      <div className="text-body gray margin-top-6 margin-bottom-medium">
          Do you intend to publish by any means data or images that were obtained or created by the operation of any UAS operated by you or on your behalf?
        <br />
      </div>
      <RadioGroup onChange={handlePublishableOnChange}>
        <Grid container justifyContent="flex-start">
          <FormControlLabel
            value={"true"}
            control={
              <Radio
                checked={fleetInformation.fleetIsPublishable === "true"}
                color="primary"
              />
            }
            label="Yes"
            labelPlacement="end"
          />
          <FormControlLabel
            value={"false"}
            control={
              <Radio
                checked={fleetInformation.fleetIsPublishable === "false"}
                color="primary"
              />
            }
            label="No"
            labelPlacement="end"
          />
        </Grid>
      </RadioGroup>
      {fleetErrors.fleetIsPublishable && <span className="text-body red margin-top-6 margin-bottom-medium">Required</span>}

       {fleetInformation.fleetIsPublishable === "true" &&
      <>
       <div className="text-body gray margin-top-6 margin-bottom-medium">
        Do you have procedures to control the publication of data or images?
        <br />
      </div>
      <RadioGroup onChange={handleProceduresControlOnChange}>
        <Grid container justifyContent="flex-start">
          <FormControlLabel
          
            value={"true"}
            required={fleetInformation.fleetIsPublishable === "true"}
            control={
              <Radio
                checked={fleetInformation.fleetProceduresControl === "true"}
                color="primary"
              />
            }
            label="Yes"
            labelPlacement="end"
          />
          <FormControlLabel
            value={"false"}
            control={
              <Radio
                checked={fleetInformation.fleetProceduresControl === "false"}
                color="primary"
              />
            }
            label="No"
            labelPlacement="end"
          />
        </Grid>
      </RadioGroup>
      {fleetErrors.fleetProceduresControl && <span className="text-body red margin-top-6 margin-bottom-medium">Required</span>}
      </>}
    </>
  );
};
